import { useMemo, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { notifyAboutProductToVerify, openIssueModal } from "actions/pack_gdn";

import ModalIssue from "./components/ModalIssue";
import ModalProductsOverPacked from "./components/ModalProductsOverPacked";

import { ConfirmModal } from "components";

import StyledProblemBar from "./styles";

const ProblemBar = ({
  gdn_status,
  gdn_id,
  is_open_issue_modal,
  notify_about_product_to_verify_at,
  notify_about_product_over_packed_at,
  openIssueModal,
  notifyAboutProductToVerify,
  gdn_lines,
}) => {
  const [
    is_open_confirm_notify_about_product_to_verify_modal,
    openConfirmNotifyAboutProductToVerifyModal,
  ] = useState(false);

  const [
    is_open_confirm_notify_about_product_over_packed_modal,
    openConfirmNotifyAboutProductOverPackedModal,
  ] = useState(false);

  const is_all_gdn_lines_ready = useMemo(() => {
    const not_completed_gdn_lines = (gdn_lines || []).reduce((acc, line) => {
      if (
        line.status === "picked" &&
        line.problem_with_code_reported_at === null
      ) {
        acc.push(line);
      }
      return acc;
    }, []);
    return not_completed_gdn_lines.length === 0;
  }, [gdn_lines]);

  if (!["picked", "packed"].includes(gdn_status)) {
    return null;
  }

  return (
    <>
      {is_open_confirm_notify_about_product_to_verify_modal && (
        <ConfirmModal
          title="Potwierdź zgłoszenie"
          text="Czy na pewno chcesz zgłosić wszystkie produkty zamówienia do weryfikacji?"
          handleClose={() => openConfirmNotifyAboutProductToVerifyModal(false)}
          handleConfirm={async () => {
            await notifyAboutProductToVerify(gdn_id);
            openConfirmNotifyAboutProductToVerifyModal(false);
          }}
        />
      )}
      {is_open_confirm_notify_about_product_over_packed_modal && (
        <ModalProductsOverPacked
          handleClose={() =>
            openConfirmNotifyAboutProductOverPackedModal(false)
          }
        />
      )}
      {is_open_issue_modal && (
        <ModalIssue handleClose={() => openIssueModal(false)} />
      )}
      <StyledProblemBar>
        {is_all_gdn_lines_ready && (
          <button type="button" onClick={() => openIssueModal(true)}>
            <span>Problem z realizacją zamówienia</span>
          </button>
        )}
        <button
          type="button"
          disabled={!!notify_about_product_to_verify_at}
          onClick={() => openConfirmNotifyAboutProductToVerifyModal(true)}
        >
          {notify_about_product_to_verify_at ? (
            <span>
              Zgłoszono produkty do weryfikacji <br />
              {moment(notify_about_product_to_verify_at).format(
                "DD.MM.YYYY HH:mm",
              )}
            </span>
          ) : (
            <span>Weryfikacja pozycji zamówienia</span>
          )}
        </button>
        <button
          type="button"
          disabled={!!notify_about_product_over_packed_at}
          onClick={() => openConfirmNotifyAboutProductOverPackedModal(true)}
        >
          {notify_about_product_over_packed_at ? (
            <span>
              Zgłoszono nadstanowe produkty w kuwecie <br />
              {moment(notify_about_product_over_packed_at).format(
                "DD.MM.YYYY HH:mm",
              )}
            </span>
          ) : (
            <span>Nadstan produktów</span>
          )}
        </button>
      </StyledProblemBar>
    </>
  );
};

export default connect(
  ({ pack_gdn: { data, is_open_issue_modal } }) => ({
    gdn_status: data?.status,
    gdn_id: data?.id,
    gdn_lines: data?.gdn_lines,
    notify_about_product_to_verify_at: data?.notify_about_product_to_verify_at,
    notify_about_product_over_packed_at:
      data?.notify_about_product_over_packed_at,
    is_open_issue_modal,
  }),
  (dispatch) => ({
    openIssueModal: (is_open) => dispatch(openIssueModal(is_open)),
    notifyAboutProductToVerify: (id) =>
      dispatch(notifyAboutProductToVerify(id)),
  }),
)(ProblemBar);
